import { get, post } from './api'

const LCL_PREFIX = '/blade-portal/lcl'

export const lclService = {
  /**
   * 获取可用的LCL船期 (访客可用)
   */
  async getAvailableShipments(params = {}) {
    const response = await get(`${LCL_PREFIX}/shipments`, {
      destinationCountry: params.destinationCountry,
      shippingMethod: params.shippingMethod,
    })
    return response
  },

  /**
   * 获取船期详情
   */
  async getShipmentDetail(id) {
    const response = await get(`${LCL_PREFIX}/shipment/${id}`)
    return response
  },

  /**
   * 创建LCL订单
   */
  async createOrder(data) {
    const response = await post(`${LCL_PREFIX}/order/create`, {
      shipmentId: data.shipmentId,
      cargoName: data.cargoName,
      weight: data.weight,
      volume: data.volume,
      quantity: data.quantity,
      remarks: data.remarks,
    })
    return response
  },

  /**
   * 获取客户的LCL订单列表
   */
  async getOrders(params = {}) {
    const response = await get(`${LCL_PREFIX}/orders`, {
      current: params.current || 1,
      size: params.size || 20,
      status: params.status,
    })
    return response
  },

  /**
   * 获取订单详情
   */
  async getOrderDetail(id) {
    const response = await get(`${LCL_PREFIX}/order/${id}`)
    return response
  },

  /**
   * 取消订单
   */
  async cancelOrder(id) {
    const response = await post(`${LCL_PREFIX}/order/cancel`, { id })
    return response
  },
}

export default lclService
